<template>
  <div class="jumbotron jumbotron--small">
    <h2 class="h1" v-if="!errorPage">
      {{ $t("which_set_use") }}
    </h2>
    <h2 class="h2" v-if="!errorPage">
      <span
        v-for="item in items"
        :key="item.key"
        :class="activeClass(item.key)"
      >
        <router-link :to="localizedLink(datasetDetailLink(item))">{{
          swaggerObject.getSummary(item.key)
        }}</router-link>
      </span>
    </h2>
    <div class="jumbotron__buttons btn-group" v-if="!errorPage">
      <Button :link="localizedLink('documentation')" type="primary">
        {{ $t("documentation") }}
      </Button>
      <Button :link="localizedLink(authorizationLink)" type="secondary">
        {{ $t("get_api_key") }}
      </Button>
    </div>
    <img
      class="jumbotron__img-big"
      src="@/assets/images/illustration-secondary.svg"
      :alt="$t('portal')"
    />
    <img
      class="jumbotron__img-small"
      src="@/assets/images/illustration-secondary-small.svg"
      :alt="$t('portal')"
    />
  </div>
</template>

<script>
import { localizedLink, orgConfig, swaggerUrl } from "@/mixins";
import Button from "@/components/homepage/Button";
import SwaggerObject from "@/helpers/SwarggerObject";
import { filterData } from "@/lib/helpers";

export default {
  mixins: [localizedLink, orgConfig, swaggerUrl],
  components: {
    Button
  },
  props: {
    authorizationLink: {
      type: Object,
      required: true
    },
    errorPage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    datasetDetailLink(item) {
      return { name: "datasets", hash: `dataset=${item.key}` };
    },
    activeClass(itemKey) {
      return this.activeItem === itemKey
        ? "item item-active"
        : "item item-inactive";
    },
    setRandomItem() {
      const activeItem = this.items[(Math.random() * this.items.length) | 0];
      this.activeItem = activeItem.key;
    },
    startRandomizer() {
      this.setRandomItem();

      setTimeout(() => {
        this.setRandomItem();
        this.startRandomizer();
      }, 2000);
    }
  },
  mounted() {
    if (window.__PRERENDER_INJECTED) {
      this.items = [];
      this.swaggerObject = {};
      return;
    }

    const swagger = new SwaggerObject();

    swagger
      .init(this.swaggerUrl(true))
      .then(() => {
        this.swaggerObject = swagger;
        this.items = filterData(this.swaggerObject.datasets);
        this.startRandomizer();
      })
      .catch(() => {
        this.$message({
          type: "error",
          message: this.$t("common.flashMessages.somethingWentWrong")
        });
      });
  },
  data: function() {
    return {
      activeItem: "",
      items: [],
      swaggerObject: null
    };
  }
};
</script>

<style lang="scss" scoped>
.item-inactive {
  display: none;
}

.jumbotron {
  max-width: $--container-jumbotron;
  margin-left: auto;
  margin-right: auto;
  padding: 80px $--gutter-landing-width / 2 72px;
  @media (max-width: $breakpoint-xs - 1) {
    padding: 50px $--gutter-landing-width 40px;
  }

  .h2 {
    color: $--color-landing-primary;
  }

  img {
    display: block;
    margin-top: 63px;
    width: 100%;
  }

  .jumbotron__img-small {
    margin-top: 0;
    margin-bottom: 40px;
    @media (min-width: $breakpoint-xs) {
      display: none;
    }
  }

  .jumbotron__img-big {
    @media (max-width: $breakpoint-xs - 1) {
      display: none;
    }
  }
}

.jumbotron--small {
  max-width: $--container-jumbotron-small;
  overflow: hidden;
  padding-bottom: 0;
  @media (max-width: $breakpoint-xs - 1) {
    padding-top: 30px;
  }

  img {
    margin-top: -140px;
    pointer-events: none;
  }

  .jumbotron__img-small {
    margin-bottom: 0;
    width: calc(100% + 60px);
    max-width: calc(100% + 60px);
    margin-left: -30px;
    margin-right: -30px;
    margin-top: -8px;
    display: block;
    @media (min-width: $breakpoint-md) {
      display: none;
    }
  }

  .jumbotron__img-big {
    @media (max-width: $breakpoint-md - 1) {
      display: none;
    }
  }
}

.jumbotron__buttons {
  margin-top: 45px;
  text-align: center;
  @media (max-width: $breakpoint-xs - 1) {
    margin-top: 20px;
  }
}
</style>
